import $ from 'jquery';

/**
 * 1つ以上のチェックボックスがチェックされていることを検証する
 * 
 * 以下のように、チェックボックスのグループを作成する
 * ```
 * <div class="js-require-one-checkbox-group">
 *  <input type="checkbox" class="js-require-one-checkbox" name="hoge[]" value="1">
 *  <input type="checkbox" class="js-require-one-checkbox" name="hoge[]" value="2">
 *  <input type="checkbox" class="js-require-one-checkbox" name="hoge[]" value="3">
 *  <input type="checkbox">
 * </div>
 * ```
 * 
 * - `.js-require-one-checkbox-group` は、1つ以上のチェックボックスがチェックされていることを検証するグループを表すクラス
 * - `.js-require-one-checkbox` は、検証対象のチェックボックスを表すクラス
 * - `.js-require-one-checkbox-group` の中には、 `.js-require-one-checkbox` 以外のチェックボックスが含まれていても良く、そのチェックボックスは検証対象にはならない
 */
document.addEventListener('DOMContentLoaded', () => {
  $('.js-validate-require-one-checkbox').on('click', (e) => {
    for (const elem of $('.js-require-one-checkbox-group').toArray()) {
      const firstCheckboxEl = $(elem).find('input[type="checkbox"].js-require-one-checkbox').get(0)
      if (!firstCheckboxEl) {
        continue
      }

      const valid = $(elem).find('input[type="checkbox"].js-require-one-checkbox:checked').length > 0
      if (valid) {
        firstCheckboxEl.setCustomValidity('')
        firstCheckboxEl.reportValidity()
      } else {
        firstCheckboxEl.setCustomValidity('これらのオプションから１つ以上選択してください。')
        firstCheckboxEl.reportValidity()
        firstCheckboxEl.scrollIntoView()
        e.preventDefault()
        break
      }
    }
  })
})
